/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Point_ExperienceInputs */



/**
* | output |
* | --- |
* | "Decades of sea-going experience" |
*
* @param {Team_Point_ExperienceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_point_experience = /** @type {((inputs?: Team_Point_ExperienceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Point_ExperienceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("数十年的航海经验")
	return /** @type {LocalizedString} */ ("Decades of sea-going experience")
});